import React, { useState, useEffect } from 'react';
import Checkbox from "@material-ui/core/Checkbox";
import WorkorderItemService from "../../services/workorderitems"
import moment from "moment";
export default function CheckList(props) {
    const [orderItems, setOrderItems] = useState([]);

    useEffect(() => {
        let items = props.orderItems;
        if (props.onlyChecked) {
            items = items.filter((item) => { return (item.checked === true) })
        }
        setOrderItems(items);
    }, [props.orderItems])

    const onChange = (orderItem) => {
        let item = Object.assign({}, orderItem);
        item.checked = !item.checked;
        props.onUpdate(item)
    }

    const list = orderItems.map((item) => {
        return (<tr key={item.guid}><td>{!props.onlyChecked && <Checkbox onChange={() => onChange(item)} checked={item.checked || false} />}</td><td>{moment(item.date).format('dddd DD MMMM')}</td><td>-</td><td>{item.project.name}</td><td>{WorkorderItemService.getTotals([item])}</td></tr>)
    })
    return (
        <div>
            <table>
                <tbody>
                    {list}
                </tbody>
            </table>
        </div>
    )
}